/**
 * Vet landing — all events modal (calendar + list). Uses window.__VET_LANDING_EVENTS__ (filled after mock/API fetch).
 */
(function () {
  'use strict';

  function getEvents() {
    if (typeof window.__VET_LANDING_GET_FILTERED_EVENTS__ === 'function') {
      return window.__VET_LANDING_GET_FILTERED_EVENTS__() || [];
    }
    if (Array.isArray(window.__VET_LANDING_FILTERED_EVENTS__)) {
      return window.__VET_LANDING_FILTERED_EVENTS__.slice();
    }
    return window.__VET_LANDING_EVENTS__ || [];
  }

  function initEventsModal() {
    var modal = document.getElementById('events-modal');
    var modalList = document.getElementById('modal-events-list');
    var modalFilter = document.getElementById('modal-event-filter');
    var calGrid = document.getElementById('cal-grid');
    var calMonthLabel = document.getElementById('cal-month-label');
    var calClear = document.getElementById('cal-clear');
    var calHint = document.getElementById('modal-cal-hint');
    var lastFocus = null;
    var viewYear = new Date().getFullYear();
    var viewMonth = new Date().getMonth();
    var selectedDateISO = null;

    if (!modal || !modalList || !modalFilter || !calGrid) return;

    function setSharedFilter(value, source) {
      if (typeof window.__VET_LANDING_SET_SEARCH_FILTER__ === 'function') {
        window.__VET_LANDING_SET_SEARCH_FILTER__(value, source || 'modal');
      }
    }

    function pad2(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function filterEvents(q) {
      var mockEvents = getEvents();
      var t = (q || '').trim().toLowerCase();
      if (!t) return mockEvents.slice();
      return mockEvents.filter(function (ev) {
        var cityFallback = (ev.address || '').split(',').slice(-2, -1)[0] || '';
        return (
          (ev.city && ev.city.toLowerCase().indexOf(t) !== -1) ||
          cityFallback.toLowerCase().indexOf(t) !== -1 ||
          (ev.state && ev.state.toLowerCase().indexOf(t) !== -1) ||
          (ev.zip && String(ev.zip).indexOf(t) !== -1) ||
          (ev.address && ev.address.toLowerCase().indexOf(t) !== -1) ||
          (ev.store && ev.store.toLowerCase().indexOf(t) !== -1)
        );
      });
    }

    function eventDatesSet(events) {
      var s = {};
      events.forEach(function (ev) {
        var iso = ev.dateISO;
        if (!iso && ev.start) {
          var dt = new Date(ev.start);
          if (!isNaN(dt.getTime())) iso = dt.toISOString().slice(0, 10);
        }
        if (iso) s[iso] = true;
      });
      return s;
    }

    function formatDateHeading(iso) {
      var p = iso.split('-');
      var y = parseInt(p[0], 10);
      var m = parseInt(p[1], 10) - 1;
      var d = parseInt(p[2], 10);
      var dt = new Date(y, m, d);
      return dt.toLocaleDateString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    }

    function appendEventRow(container, ev) {
      var row = document.createElement('div');
      row.className = 'modal-event-row';
      row.setAttribute('role', 'listitem');
      var calendarApi = window.__VET_LANDING_CALENDAR__ || null;
      var details = document.createElement('div');
      details.className = 'modal-event-row__details';

      var line1 = document.createElement('div');
      line1.className = 'line1';
      line1.textContent = ev.fromTo || '';

      var line2 = document.createElement('div');
      line2.className = 'line2';
      line2.textContent = ev.store || '';

      var line3 = document.createElement('div');
      line3.className = 'line3';
      line3.textContent = ev.address || ev.fullAddress || '';

      details.appendChild(line1);
      details.appendChild(line2);
      if (line3.textContent) details.appendChild(line3);

      var actions = document.createElement('div');
      actions.className = 'modal-event-row__actions';

      var calendarBtn = document.createElement('button');
      calendarBtn.type = 'button';
      calendarBtn.className = 'calendar-btn';
      calendarBtn.classList.add('calendar-btn--primary');
      calendarBtn.textContent = 'Add to calendar';
      calendarBtn.setAttribute('aria-haspopup', 'dialog');
      calendarBtn.setAttribute('aria-expanded', 'false');

      var hasCalendar =
        calendarApi && typeof calendarApi.hasCalendarData === 'function' && calendarApi.hasCalendarData(ev);
      if (!hasCalendar) {
        calendarBtn.disabled = true;
        calendarBtn.title = 'Calendar details unavailable for this event';
      } else {
        calendarBtn.addEventListener('click', function () {
          calendarApi.openPicker(ev, calendarBtn, 'calendar');
        });
      }

      var infoBtn = document.createElement('button');
      infoBtn.type = 'button';
      infoBtn.className = 'calendar-btn calendar-btn--secondary';
      infoBtn.textContent = 'More info';
      infoBtn.setAttribute('aria-haspopup', 'dialog');
      infoBtn.setAttribute('aria-expanded', 'false');

      var hasInfo =
        calendarApi &&
        ((typeof calendarApi.getDirectionsUrl === 'function' && !!calendarApi.getDirectionsUrl(ev)) ||
          (typeof calendarApi.getCallUrl === 'function' && !!calendarApi.getCallUrl(ev)));

      if (!hasInfo) {
        infoBtn.disabled = true;
        infoBtn.title = 'Store details unavailable for this event';
      } else {
        infoBtn.addEventListener('click', function () {
          calendarApi.openPicker(ev, infoBtn, 'info');
        });
      }

      actions.appendChild(calendarBtn);
      actions.appendChild(infoBtn);
      row.appendChild(details);
      row.appendChild(actions);
      container.appendChild(row);
    }

    function renderCalendar(filtered) {
      var hasByDate = eventDatesSet(filtered);
      var monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      calMonthLabel.textContent = monthNames[viewMonth] + ' ' + viewYear;

      var firstDow = new Date(viewYear, viewMonth, 1).getDay();
      var dim = new Date(viewYear, viewMonth + 1, 0).getDate();
      var prevDim = new Date(viewYear, viewMonth, 0).getDate();

      calGrid.innerHTML = '';
      var cells = [];
      var i;
      for (i = 0; i < firstDow; i++) {
        var leadDay = prevDim - firstDow + i + 1;
        var lead = document.createElement('button');
        lead.type = 'button';
        lead.className = 'cal-day is-out';
        lead.textContent = String(leadDay);
        lead.disabled = true;
        lead.tabIndex = -1;
        lead.setAttribute('aria-hidden', 'true');
        cells.push(lead);
      }
      for (var d = 1; d <= dim; d++) {
        var iso = viewYear + '-' + pad2(viewMonth + 1) + '-' + pad2(d);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cal-day';
        btn.setAttribute('role', 'gridcell');
        var label = d + ' ' + monthNames[viewMonth] + ' ' + viewYear;
        if (hasByDate[iso]) {
          btn.classList.add('has-events');
          label += ', has events';
        }
        btn.setAttribute('aria-label', label);
        if (selectedDateISO === iso) btn.classList.add('is-selected');
        btn.textContent = String(d);
        (function (dateIso) {
          btn.addEventListener('click', function () {
            selectedDateISO = selectedDateISO === dateIso ? null : dateIso;
            renderModal();
          });
        })(iso);
        cells.push(btn);
      }
      var tail = cells.length % 7;
      if (tail !== 0) {
        var need = 7 - tail;
        var nextDay = 1;
        for (i = 0; i < need; i++) {
          var trail = document.createElement('button');
          trail.type = 'button';
          trail.className = 'cal-day is-out';
          trail.textContent = String(nextDay++);
          trail.disabled = true;
          trail.tabIndex = -1;
          trail.setAttribute('aria-hidden', 'true');
          cells.push(trail);
        }
      }
      cells.forEach(function (el) {
        calGrid.appendChild(el);
      });
      calClear.hidden = !selectedDateISO;
    }

    function renderModal() {
      var filtered = filterEvents(modalFilter.value);
      renderCalendar(filtered);

      modalList.innerHTML = '';
      if (filtered.length === 0) {
        modalList.innerHTML = '<p class="modal-empty">No events match that ZIP or city. Try another search.</p>';
        if (calHint) calHint.style.display = 'none';
        return;
      }
      if (calHint) calHint.style.display = '';

      var toShow;
      if (selectedDateISO) {
        toShow = filtered.filter(function (ev) {
          var iso = ev.dateISO;
          if (!iso && ev.start) {
            var dt = new Date(ev.start);
            if (!isNaN(dt.getTime())) iso = dt.toISOString().slice(0, 10);
          }
          return iso === selectedDateISO;
        });
        if (toShow.length === 0) {
          modalList.innerHTML =
            '<p class="modal-empty">No events on ' +
            formatDateHeading(selectedDateISO) +
            ' for this search. Try another day or clear the filter.</p>';
          return;
        }
        var h = document.createElement('h4');
        h.style.margin = '0 0 10px';
        h.style.fontSize = '15px';
        h.style.fontWeight = '700';
        h.style.color = 'var(--ink)';
        h.textContent = formatDateHeading(selectedDateISO);
        modalList.appendChild(h);
        toShow.forEach(function (ev) {
          appendEventRow(modalList, ev);
        });
        return;
      }

      var byDate = {};
      filtered.forEach(function (ev) {
        var k = ev.dateISO || '';
        if (!byDate[k]) byDate[k] = [];
        byDate[k].push(ev);
      });
      var keys = Object.keys(byDate).sort();
      keys.forEach(function (k) {
        var grp = document.createElement('div');
        grp.className = 'modal-date-group';
        grp.setAttribute('role', 'group');
        var h4 = document.createElement('h4');
        h4.textContent = formatDateHeading(k);
        grp.appendChild(h4);
        byDate[k].forEach(function (ev) {
          appendEventRow(grp, ev);
        });
        modalList.appendChild(grp);
      });
    }

    var calPrev = document.getElementById('cal-prev');
    var calNext = document.getElementById('cal-next');
    if (calPrev) {
      calPrev.addEventListener('click', function () {
        viewMonth--;
        if (viewMonth < 0) {
          viewMonth = 11;
          viewYear--;
        }
        renderModal();
      });
    }
    if (calNext) {
      calNext.addEventListener('click', function () {
        viewMonth++;
        if (viewMonth > 11) {
          viewMonth = 0;
          viewYear++;
        }
        renderModal();
      });
    }
    if (calClear) {
      calClear.addEventListener('click', function () {
        selectedDateISO = null;
        renderModal();
      });
    }

    var modalCalPanel = document.getElementById('modal-calendar-panel');
    var modalCalToggle = document.getElementById('modal-cal-toggle');
    function syncCalToggle() {
      var open = modalCalPanel && !modalCalPanel.hidden;
      if (!modalCalToggle) return;
      modalCalToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      modalCalToggle.textContent = open ? 'Hide calendar' : 'Show calendar';
    }
    if (modalCalToggle && modalCalPanel) {
      modalCalToggle.addEventListener('click', function () {
        modalCalPanel.hidden = !modalCalPanel.hidden;
        syncCalToggle();
      });
    }

    function openModal() {
      lastFocus = document.activeElement;
      var heroSearch = document.getElementById('hero-location-search');
      if (heroSearch && modalFilter) modalFilter.value = heroSearch.value || '';
      selectedDateISO = null;
      if (modalCalPanel) modalCalPanel.hidden = true;
      syncCalToggle();
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      renderModal();
      setTimeout(function () {
        modalFilter.focus();
      }, 50);
    }

    function closeModal() {
      modal.setAttribute('hidden', 'hidden');
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    var btnHero = document.getElementById('btn-hero-view-events');
    var btnCta = document.getElementById('btn-cta-view-events');
    var btnNav = document.getElementById('btn-nav-all-events');
    if (btnHero) btnHero.addEventListener('click', openModal);
    if (btnCta) btnCta.addEventListener('click', openModal);
    if (btnNav) btnNav.addEventListener('click', openModal);
    var closeBtn = document.getElementById('events-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    modalFilter.addEventListener('input', function () {
      selectedDateISO = null;
      setSharedFilter(modalFilter.value, 'modal');
      renderModal();
    });
    document.addEventListener('vetlanding:searchsync', function (evt) {
      var detail = (evt && evt.detail) || {};
      if (detail.source === 'modal') return;
      var nextValue = String(detail.value || '');
      if (modalFilter.value !== nextValue) {
        modalFilter.value = nextValue;
        selectedDateISO = null;
        if (modal.classList.contains('is-open')) renderModal();
      }
    });
    document.addEventListener('vetlanding:filterschanged', function () {
      if (modal.classList.contains('is-open')) {
        selectedDateISO = null;
        renderModal();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    var heroSearch = document.getElementById('hero-location-search');
    if (heroSearch && modalFilter) {
      modalFilter.value = heroSearch.value || '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEventsModal);
  } else {
    initEventsModal();
  }
})();
